import React from 'react';
import { Box, Typography } from '@mui/material';
import Logo from '../../../UI/Logo';

const SidebarHeader = () => {
	return (
		<Box sx={{ paddingTop: 'env(safe-area-inset-top)', textAlign: 'center' }}>
			<Logo height="150px" />
		</Box>
	);
};

export default SidebarHeader;
